import Schedule from '../index';

export default Schedule;
